import React from 'react';
import classNames from 'classnames';
import EmptyStateImg from 'assets/images/loupe.webp';
import { useTranslation } from 'react-i18next';
import { Button } from 'ncoded-component-library';
import PluscircleIcon from 'icons/Pluscircle.icon';
import { useNavigate } from 'react-router-dom';
import ResolveImage from 'components/ResolveImage';

import './EnterprisesEmptyState.styles.scss';

type EnterprisesEmptyStateProps = {
  className?: string;
};

const EnterprisesEmptyState: React.FC<EnterprisesEmptyStateProps> = (props) => {
  const { className } = props;
  const { t } = useTranslation();
  const navigate = useNavigate();

  const classes = classNames('enterprises-empty-state', className);

  return (
    <div className={classes}>
      <ResolveImage
        src={EmptyStateImg}
        asIllustration
        alt="Enterprise empty state."
      />
      <p>{t('youDontHaveEnterprises')}</p>
      <Button onClick={() => navigate('add')} icon={PluscircleIcon}>
        {t('addAnEnterprise')}
      </Button>
    </div>
  );
};

export default EnterprisesEmptyState;
